import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '@components/1-atoms/Button';

export const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.level3};
  padding: ${({ theme }) => theme.spacing.level4} ${({ theme }) => theme.spacing.level5};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: ${({ theme }) => theme.colors.surfaceContainerLow};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level4};

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FieldWrapper = styled.div`
  width: 120px;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const PriceLabel = styled.span`
  ${({ theme }) => theme.font.titleMedium};
  color: ${({ theme }) => theme.colors.onSurface};
  white-space: nowrap;
  flex: 1;
`;

export const SmallButton = styled(Button)`
  flex-shrink: 0;

  span {
    padding: ${({ theme }) => theme.spacing.level2} ${({ theme }) => theme.spacing.level4};
  }
`;

export const Description = styled.p`
  ${({ theme }) => theme.font.bodySmall};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  margin: ${({ theme }) => theme.spacing.level3} 0 0;
`;

export const UpgradeMessage = styled.p`
  ${({ theme }) => theme.font.bodyMedium};
  color: ${({ theme }) => theme.colors.onSurface};
  margin: 0 0 ${({ theme }) => theme.spacing.level3};
`;

export const UpgradeLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
